import { APPEND_CALL, UPDATE_MESSENGER_SEQUENCE, MESSAGE_NEW_INBOX, MESSAGE_SEEN_INBOX, APPEND_INBOX, APPEND_RESERVATION, APPEND_ROOMINVITE, APPEND_TASK, REMOVE_ROOMINVITE, UPDATE_INBOX, UPDATE_TASK, UPDATE_CALL, ADD_OUTGOING_CALL, REMOVE_OUTGOING_CALL, REMOVE_CALL, ADD_INBOX } from '../actionsList';



const initialInfo = {
    applet: '',
    hub: '',
    messages: '',
    desk: [],
    pendingTask: [],
    reservations: [],
    list: [],
    object: {},
    categorizer: {
        applet: { list: [], count: 0 },
        portal: { count: 0 },
        hub: { list: [], count: 0 },
        request: { list: [], count: 0 },
        count: 0
    }
};

const inboxReducer = (state = initialInfo, action) => {

    // console.log(action.type)
    switch (action.type) {
        case APPEND_INBOX: {
            // let key = action.applet
            let pendingTask = state.pendingTask
            let list = [...state.list]
            let object = { ...state.object }
            let categorizer = { ...state.categorizer }

            if (!pendingTask) {
                pendingTask = []
            }
            if (!object['request']) {
                object['request'] = { list: [], count: 0 }
            }
            if (!categorizer) {
                categorizer = {}
            }
            // console.log('action', action);

            action.config.map((oneConfig) => {
                if (oneConfig.applet) {
                    if (!object[oneConfig.applet._id]) {
                        object[oneConfig.applet._id] = { count: 0 }
                    }
                }
                if (oneConfig.applet && oneConfig.frame) {
                    if (!object[oneConfig.applet._id][oneConfig.frame]) {
                        object[oneConfig.applet._id][oneConfig.frame] = { list: [], count: 0 }
                    }
                }
                if (!oneConfig.features) {
                    oneConfig.features = []
                }
                if (!categorizer[oneConfig.features[0]]) {
                    categorizer[oneConfig.features[0]] = { list: [], count: 0 }
                }





                if (oneConfig.type == 'notifier') {

                    let found = false
                    let lIndex
                    list.map((item, index) => {
                        if (item.title == oneConfig.title && String(item.frame?._id) == String(oneConfig.frame?._id)) {
                            found = true
                            lIndex = index
                        }
                    })
                    let oIndex
                    let objFound = false
                    // console.log('oneConfig.applet', oneConfig.applet._id)
                    // console.log('oneConfig.frame', oneConfig.frame)
                    if (object[oneConfig.applet._id] && object[oneConfig.applet._id][oneConfig.frame]) {
                        object[oneConfig.applet._id][oneConfig.frame].list.map((element, index) => {
                            if (element.type == 'notifier' && element.title == oneConfig.title) {
                                oIndex = index
                                objFound = true
                            }
                        })
                    }
                    let cIndex
                    let pCategorizerFound = false
                    if (categorizer[oneConfig.features[0]]) {
                        categorizer[oneConfig.features[0]].list.map((element, index) => {
                            if (element.type == 'notifier' && element.title == oneConfig.title) {
                                cIndex = index
                                pCategorizerFound = true
                            }
                        })

                    }
                    if (found) {
                        list[lIndex].count += 1
                    }
                    else {
                        list.push({ title: oneConfig.title, count: 1, type: 'notifier', cDate: oneConfig.cDate, applet: oneConfig.applet._id })
                        // console.log('gerere', object[oneConfig.applet._id][oneConfig.frame])

                    }
                    if (objFound) {
                        if (object[oneConfig.applet?._id]) {
                            object[oneConfig.applet._id].count += 1
                        }
                        if (object[oneConfig.applet?._id] && object[oneConfig.applet._id][oneConfig.frame]) {
                            object[oneConfig.applet._id][oneConfig.frame].list[oIndex].count += 1
                            object[oneConfig.applet._id][oneConfig.frame].count += 1
                        }
                    }
                    else {
                        if (oneConfig.applet && oneConfig.frame) {
                            object[oneConfig.applet._id][oneConfig.frame].list.push({ title: oneConfig.title, count: 1, type: 'notifier', cDate: oneConfig.cDate, applet: oneConfig.applet._id })
                            object[oneConfig.applet._id][oneConfig.frame].count += 1
                        }
                        if (oneConfig.applet) {
                            object[oneConfig.applet._id].count += 1
                        }

                    }
                    if (pCategorizerFound) {
                        categorizer.count += 1
                        categorizer[oneConfig.features[0]].count += 1
                        categorizer[oneConfig.features[0]].list[cIndex].count += 1
                    }
                    else {
                        categorizer[oneConfig.features[0]].list.push({ title: oneConfig.title, count: 1, type: 'notifier', cDate: oneConfig.cDate, applet: oneConfig.applet._id })
                        categorizer[oneConfig.features[0]].count += 1
                        categorizer.count += 1
                    }

                }
                else {
                    list.push(oneConfig)
                    if (oneConfig.applet?._id && object[oneConfig.applet._id][oneConfig.frame]) {
                        object[oneConfig.applet._id][oneConfig.frame].list.push(oneConfig)
                        object[oneConfig.applet._id][oneConfig.frame].count += 1
                    }
                    else {
                        object['request'].list.push(oneConfig)
                        object['request'].count += 1
                    }
                    categorizer[oneConfig.features[0]].list.push(oneConfig)
                    categorizer[oneConfig.features[0]].count += 1
                }
                list = list.sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())
                if (object[oneConfig.applet?._id] && object[oneConfig.applet._id][oneConfig.frame]) {
                    object[oneConfig.applet._id][oneConfig.frame].list = object[oneConfig.applet._id][oneConfig.frame].list.sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())
                }
                if (object['request']) {
                    object['request'].list = object['request'].list.sort((a, b) => new Date(b.cDate).getTime() - new Date(a.cDate).getTime())
                }
                // console.log('objecttsorted,', object)
                // console.log('listsorted,', list)


                // else if (oneConfig.type == 'roomInvitation') {
                //     let found = false
                //     list.forEach(oneList => {
                //         if (oneList.roomId == oneConfig.roomId && oneList.type == oneConfig.type) {
                //             found = true
                //         }
                //     })
                //     if (!found) {
                //         list.push(oneConfig)
                //     }
                //     console.log('rooooms', list)
                // }
                // else if (oneConfig.type == 'acceptCall') {
                //     let found = false
                //     let cIndex
                //     list.forEach((oneList, index) => {
                //         if (oneList.roomId == oneConfig.roomId && oneList.type == oneConfig.type && oneConfig.status) {
                //             found = true
                //             cIndex = index
                //         }
                //     })
                //     if (!found) {
                //         list.push(oneConfig)
                //     }
                // }


                // else if (oneConfig.type == 'outGoingCall') {

                // }
            })

            // console.log(key)
            // console.log(pendingTask)

            return {
                ...state,
                pendingTask: pendingTask,
                list: list,
                object: object,
                categorizer: categorizer,
            }
        }
        case ADD_INBOX: {
            // let pendingTask = []

            let object = {}
            let categorizer = {}
            let appletHubs = {}
            let messengers = {}

            // if (!pendingTask) {
            //     pendingTask = []
            // }


            // TO DO: REQUEST
            // if (!object['request']) {
            //     object['request'] = { list: [], count: 0 }
            // }

            action.inboxes?.map((oneConfig) => {

                extractInbox(oneConfig, object, appletHubs, categorizer)

            })


            action.messengers?.map((messenger) => {

                extractMessengerInbox(messenger, object, messengers, appletHubs, categorizer, action.hub)

            })

            // console.log("action.hub",action.hub)


            return {
                ...state,
                // pendingTask: pendingTask,
                // list: list,
                object: object,
                appletHubs,
                categorizer,
                messengers,
                inboxList: action.inboxes,
                messengersList: action.messengers,
                messengersHub: action.hub
            }
        }
        case UPDATE_INBOX: {

            // console.log("UPDATE_INBOX")
            let object = { ...state.object }
            let categorizer = { ...state.categorizer }
            let appletHubs = { ...state.appletHubs }
            let inboxList = [...state.inboxList]


            let inbox = { ...action.inbox }
            let oldInbox
            let countDifference = inbox.count ?? 0

            if (inbox) {

                // let frameId = inbox.frame?._id ?? inbox.frame
                // let appletId = inbox.applet?._id ?? inbox.applet
                // let appletHubId = inbox.appletHub?._id ?? inbox.appletHub

                let found = false
                inboxList.forEach((oneInbox, index) => {
                    if (oneInbox._id == inbox._id) {
                        oldInbox = oneInbox
                        inboxList[index] = { ...inbox }
                        found = true
                    }
                });

                if (!found) {
                    inboxList.push(inbox)
                }

                // console.log("oldInbox",oldInbox)

                if (oldInbox) {
                    countDifference = countDifference - oldInbox.count

                    inbox.count = countDifference
                }

                // console.log("countDifference",countDifference)


                extractInbox(inbox, object, appletHubs, categorizer)

            }

            return {
                ...state,
                object,
                categorizer,
                appletHubs,
                inboxList
            }
        }


        case UPDATE_MESSENGER_SEQUENCE: {

            let messengersList = [...state.messengersList]
            let messengers = { ...state.messengers }

            let currentMessenger = messengers[action.id]

            if (currentMessenger) {

                if (action.sequence > currentMessenger.sequence) {
                    currentMessenger.sequence = action.sequence
                }

                if (action.hubSequence > currentMessenger.hubSequence) {
                    currentMessenger.hubSequence = action.hubSequence
                }
            }

            return {
                ...state,
                messengers,
                messengersList
            }
        }

        case MESSAGE_SEEN_INBOX: {


            // console.log("MESSAGE_SEEN_INBOX")

            let info = { ...action.info }
            let messengersHub = state.messengersHub

            if (info && info.by == messengersHub) {

                // console.log("MESSAGE_SEEN_INBOX TP1")


                let object = { ...state.object }
                let categorizer = { ...state.categorizer }
                let appletHubs = { ...state.appletHubs }
                let messengersList = [...state.messengersList]
                let messengers = { ...state.messengers }



                // console.log("messengersList", messengersList)
                let oldMessenger = messengers[info.messenger]

                // console.log("oldMessenger", oldMessenger, oldMessenger.hubSequence, info.sequence)


                if (oldMessenger && oldMessenger.hubSequence < info.sequence) {

                    // console.log("MESSAGE_SEEN_INBOX TP2")

                    let oldInbox
                    let oldDifference = oldMessenger.sequence - oldMessenger.hubSequence
                    let newDifference = oldMessenger.sequence - info.sequence
                    let finalDifference = newDifference - oldDifference

                    // console.log("MESSAGE_SEEN_INBOX", JSON.parse(JSON.stringify(oldMessenger)), oldMessenger.sequence, info.sequence)
                    // console.log("MESSAGE_SEEN_INBOX", oldMessenger.sequence, oldMessenger.hubSequence, info.sequence, oldDifference, newDifference, finalDifference)


                    messengers[info.messenger].hubSequence = info.sequence

                    let found = false
                    messengersList.forEach((oneInbox, index) => {
                        if (oneInbox._id == info.messenger) {

                            messengersList[index].sequence = oldMessenger.sequence
                            if (!messengersList[index].hubSequences) {
                                messengersList[index].hubSequences = {}
                            }
                            messengersList[index].hubSequences[messengersHub] = info.sequence

                            oldInbox = messengersList[index]

                            // messengersList[index] = { ...inbox }
                            found = true
                        }
                    })

                    // console.log("MESSAGE_SEEN_INBOX finalDifference",finalDifference)

                    extractMessengerInbox(oldInbox, object, messengers, appletHubs, categorizer, messengersHub, finalDifference)


                    // countDifference =

                    // console.log("oldInbox", oldInbox)
                    // console.log("messengers[info.messenger]", messengers[info.messenger])


                    // if (found) {
                    //     // countDifference = countDifference - oldInbox.count

                    //     // inbox.count = countDifference
                    // }


                    // extractInbox(inbox, object, appletHubs, categorizer)

                }

                return {
                    ...state,
                    object,
                    categorizer,
                    appletHubs,
                    messengers,
                    messengersList
                }
            } else {
                return {
                    ...state,
                }
            }


        }




        case MESSAGE_NEW_INBOX: {

            // console.log("MESSAGE_NEW_INBOX", action.info)
            let info = { ...action.info }


            let messengersHub = state.messengersHub

            if (info) {



                let object = { ...state.object }
                let categorizer = { ...state.categorizer }
                let appletHubs = { ...state.appletHubs }
                let messengersList = [...state.messengersList]
                let messengers = { ...state.messengers }

                // console.log("MESSAGE_NEW_INBOX", messengers)


                // console.log("messengersList", messengersList)
                // console.log("messengers", messengers,info.messenger?._id)
                let oldMessenger = messengers[info.messenger?._id]

                // console.log("oldMessenger", oldMessenger)

                if (!oldMessenger) {
                    messengersList.push(info.messenger)

                    extractMessengerInbox(info.messenger, object, messengers, appletHubs, categorizer, (info.hub ?? action.hub))
                    oldMessenger = messengers[info.messenger?._id]


                }

                // console.log("oldMessenger", oldMessenger)

                // console.log("MESSAGE_NEW_INBOX", oldMessenger, oldMessenger?.hubSequence, info.message.sequence)


                if (oldMessenger && oldMessenger.hubSequence < info.message.sequence) {

                    let oldInbox
                    // let oldDifference = oldMessenger.sequence - oldMessenger.hubSequence
                    // let newDifference = info.message.sequence - oldMessenger.sequence
                    let finalDifference = info.message.sequence - oldMessenger.sequence

                    // console.log("action.isSender", action.isSender)
                    if (action.isSender) {
                        finalDifference = 0
                    }
                    // console.log("info.message.sequence", info.message.sequence, oldMessenger.sequence)


                    // messengers[info.messenger].hubSequence = info.sequence

                    let found = false
                    messengersList.forEach((oneInbox, index) => {
                        if (oneInbox._id == info.messenger?._id) {
                            oldInbox = oneInbox
                            messengersList[index].sequence = info.message.sequence

                            if (action.isSender) {
                                if (!messengersList[index].hubSequences) {
                                    messengersList[index].hubSequences = {}
                                }
                                messengersList[index].hubSequences[messengersHub] = info.message.sequence
                            }
                            // messengersList[index] = { ...inbox }
                            found = true
                        }
                    })

                    // console.log("oldInbox", oldInbox, messengersList)

                    if (!found) {
                        if (info.messenger.sequence == null) {
                            info.messenger.sequence = info.message.sequence
                        }
                        messengersList.push(info.messenger)
                    }

                    messengers[info.messenger?._id].sequence = info.message.sequence
                    messengers[info.messenger?._id].uDate = info.message.cDate

                    if (action.isSender) {
                        messengers[info.messenger?._id].hubSequence = info.message.sequence
                    }

                    oldInbox.sequence = info.message.sequence

                    // console.log("finalDifference", finalDifference)

                    extractMessengerInbox(oldInbox, object, messengers, appletHubs, categorizer, messengersHub, finalDifference)


                    // countDifference =

                    // console.log("oldInbox", oldInbox)
                    // console.log("messengers[info.messenger]", messengers[info.messenger])


                    // if (found) {
                    //     // countDifference = countDifference - oldInbox.count

                    //     // inbox.count = countDifference
                    // }


                    // extractInbox(inbox, object, appletHubs, categorizer)

                }

                return {
                    ...state,
                    object,
                    categorizer,
                    appletHubs,
                    messengers,
                    messengersList
                }
            }

            break;

        }


        case ADD_OUTGOING_CALL: {
            let list = [...state.list]
            action.config.forEach((element) => {
                let found = false
                list.forEach((oneList) => {
                    if (element.type == oneList.type && element.roomId == oneList.roomId) {
                        found = true
                    }
                })
                if (!found) {
                    list.push(element)
                }
            })
            return {
                ...state,
                list: list,
            }
        }
        case REMOVE_OUTGOING_CALL: {
            let list = [...state.list]
            // console.log('REMOVE_OUTGOING_CALL', [...state.list])
            // console.log('list is', list)
            action.config.forEach((element) => {
                let found = false
                let cIndex
                list.forEach((oneList, index) => {
                    // console.log('onelist', oneList.roomId)
                    // console.log('onelist', oneList.type)
                    if (element.type == oneList.type && element.roomId == oneList.roomId) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    list.splice(cIndex, 1)
                    // console.log('list is00', list, cIndex)

                }
            })
            setTimeout(() => {
                // console.log('list is00', list)
            }, 20);
            return {
                ...state,
                list: list,
            }
        }
        case APPEND_TASK: {

            let desk = state.desk

            if (!desk) {
                desk = []
            }
            // console.log('desk action', action);
            // console.log(' action tasks', action.tasks);
            // console.log('desk desk', desk);


            action.tasks?.map((task) => {
                let found = false
                desk.map((oneDesk) => {
                    // console.log('one desk', oneDesk)
                    if (task._id == oneDesk._id) {
                        found = true
                    }
                })
                if (!found) {
                    desk.push(task)
                }
            })

            // console.log(key)
            // console.log(list)

            return {
                ...state,
                desk: desk,
            }
        }
        case UPDATE_TASK: {
            let desk = state.desk

            if (!desk) {
                desk = []
            }
            console.log(action)
            action.config?.map((task) => {
                let found = false
                let cIndex
                desk.map((oneDesk, index) => {
                    // console.log('one desk', oneDesk)
                    if (task._id == oneDesk._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    // console.log('updated task', task)
                    // console.log('last desk', desk[cIndex])
                    desk[cIndex] = task
                }
            })
            // console.log(key)
            // console.log(list)

            return {
                ...state,
                desk: desk,
            }
        }
        case APPEND_RESERVATION: {
            let reservations = state.reservations

            if (!reservations) {
                reservations = []
            }
            // console.log('reservation action', action);
            // console.log(' action tasks', action.reservation);
            // console.log('reservation reservation', reservations);


            action.reservation?.map((reservation) => {
                let found = false
                reservations.map((oneDesk) => {
                    // console.log('one desk', oneDesk)
                    if (reservation._id == oneDesk._id) {
                        found = true
                    }
                })
                if (!found) {
                    reservations.push(reservation)
                }
            })

            // console.log(key)
            // console.log(list)

            return {
                ...state,
                reservations: reservations,
            }
        }
        case APPEND_ROOMINVITE: {
            let list = [...state.list]
            action.room.forEach(element => {
                let found = false
                list.forEach(oneList => {
                    if (oneList.roomId == element.roomId && oneList.type == element.type) {
                        found = true
                    }
                })
                if (!found) {
                    list.push(element)
                }
            });
            // console.log('action.room', action.room)
            return {
                ...state,
                list: list,
            }
        }
        case REMOVE_ROOMINVITE: {
            let list = [...state.list]
            action.room.forEach(element => {
                let found = false
                let cIndex
                list.forEach((oneList, index) => {
                    // console.log('one list', oneList)
                    // console.log('element.type', element)
                    if (oneList?.roomId == element?.roomId && oneList.type == element?.type) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    list.splice(cIndex, 1)
                }
            });
            return {
                ...state,
                list: list,
            }
        }
        case APPEND_CALL: {
            let list = [...state.list]
            action.room.forEach(element => {
                let found = false
                let cIndex
                console.log('actions', action)
                list.forEach((oneList, index) => {
                    console.log('roomid', oneList.roomId)
                    if (oneList.roomId == element.roomId && element.type == oneList.type && element.status) {
                        found = true
                        cIndex = index
                    }
                })
                if (!found) {
                    list.push(element)
                }
            });
            return {
                ...state,
                list: list,
            }
        }
        case REMOVE_CALL: {
            let list = [...state.list]
            action.room?.forEach(element => {
                let found = false
                let cIndex
                console.log('actions', action)
                list.forEach((oneList, index) => {
                    if (oneList.roomId == element.roomId && element.type == oneList.type) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    list.splice(cIndex, 1)
                }
            });
            return {
                ...state,
                list: list,
            }
        }
        case UPDATE_CALL: {
            let list = [...state.list]
            action.room.forEach(element => {
                let found = false
                let cIndex
                list.forEach((oneList, index) => {
                    if (oneList.roomId == element.roomId && oneList.type == element.type && element.status) {
                        found = true
                        cIndex = index
                    }
                })
                if (found) {
                    list[cIndex].used = true
                }
            });
            return {
                ...state,
                list: list,
            }
        }
        default:
            return state;
    }
}


const extractInbox = (inbox, object, appletHubs, categorizer) => {

    let frameId = inbox.frame?._id ?? inbox.frame
    let appletId = inbox.applet?._id ?? inbox.applet
    let appletHubId = inbox.appletHub?._id ?? inbox.appletHub

    // console.log("extractInbox", frameId, appletId, appletHubId)
    if (appletId) {


        if (!object[appletId]) {
            object[appletId] = { count: 0, frames: {}, info: inbox.applet }
        }

        object[appletId].count += (inbox.count ?? 0)
    }

    // console.log(appletId, frameId)
    if (appletId && frameId) {

        if (!object[appletId].frames[frameId]) {
            object[appletId].frames[frameId] = { list: [], count: 0, info: inbox.frame }
        }

        object[appletId].frames[frameId].count += (inbox.count ?? 0)
    }
    // console.log(object[appletId])


    if (appletHubId) {
        if (!appletHubs[appletHubId]) {
            appletHubs[appletHubId] = { list: [], count: 0, info: inbox.appletHub }
        }
        appletHubs[appletHubId].count += (inbox.count ?? 0)
    }


    let type

    if (inbox.type == 'request' || inbox.type == 'system') {

        // console.log("appletHubId",appletHubId,appletHubs[appletHubId])

        type = inbox.type
        let topic = inbox.topic

        if (!categorizer[type]) {
            categorizer[type] = { hubs: {}, count: 0 }
        }

        categorizer[type].count += (inbox.count ?? 0)


        if (appletHubId) {

            if (!categorizer[type].hubs[appletHubId]) {
                categorizer[type].hubs[appletHubId] = { count: 0, info: inbox.appletHub, topics: {} }
            }

            categorizer[type].hubs[appletHubId].count += (inbox.count ?? 0)

            if (topic) {


                if (!categorizer[type].hubs[appletHubId].topics[topic]) {
                    categorizer[type].hubs[appletHubId].topics[topic] = { count: 0, topic }
                }

                categorizer[type].hubs[appletHubId].topics[topic].count += (inbox.count ?? 0)

            }
        }

        if (inbox.type == 'request') {
            type = 'settings'
            if (!categorizer[type]) {
                categorizer[type] = { list: [], count: 0 }
            }

            categorizer[type].count += (inbox.count ?? 0)
        }

    } else {

        let type = inbox.frame?.type?.toLowerCase()

        if (!categorizer[type]) {
            categorizer[type] = { list: [], count: 0 }
        }

        categorizer[type].count += (inbox.count ?? 0)

    }
    type = '*'
    if (!categorizer[type]) {
        categorizer[type] = { list: [], count: 0 }
    }

    categorizer[type].count += (inbox.count ?? 0)

}







const extractMessengerInbox = (messenger, object, messengers, appletHubs, categorizer, hub, differenceCount) => {



    // console.log("extractMessengerInbox",hub)
    if (Array.isArray(messenger.interactiveUsers) && hub) {




        for (let i = 0; i < messenger.interactiveUsers.length; i++) {
            const user = messenger.interactiveUsers[i];
            if ((user.hub._id ?? user.hub) == hub) {

                let frameId
                let appletId
                let appletHubId
                let count = 0


                // console.log("extractMessengerInbox TP1")

                // frameId = user.frame?._id
                // appletId = user.frame?.applet
                // appletHubId = user.refHub
                if (Array.isArray(user.refs)) {

                    let messengerIsDone = false
                    let doneFrames = []

                    for (let r = 0; r < user.refs.length; r++) {
                        const ref = user.refs[r];

                        frameId = ref.frame?._id ?? ref.frame
                        appletId = ref.applet ? (ref.applet._id ?? ref.applet) : ref.frame?.applet
                        appletHubId = ref.hub?._id ?? ref.hub


                        // console.log("extractMessengerInbox TP2",)

                        // console.log("extractInbox", messenger)
                        if (frameId) {

                            let sequence = messenger.sequence ?? 0
                            let hubSequence = messenger.hubSequences ? (messenger.hubSequences[hub] ?? 0) : 0
                            count = differenceCount != null ? differenceCount : (sequence - hubSequence)


                            // console.log("HERE -> ", messenger._id, messenger.sequence, hubSequence, messengerIsDone, count)

                            if (!messengerIsDone) {


                                if (!messengers[messenger._id]) {
                                    messengers[messenger._id] = { count: 0, totalCount: 0, frame: frameId, applet: appletId, appletHub: appletHubId }
                                }
                                // console.log(messengers[messenger._id].count)
                                messengers[messenger._id].count += count
                                messengers[messenger._id].totalCount += count
                                messengers[messenger._id].hubSequence = hubSequence
                                messengers[messenger._id].sequence = sequence

                                if (messenger.parent) {

                                    let parent = messenger.parent?._id ?? messenger.parent

                                    if (!messengers[parent]) {
                                        messengers[parent] = { count: 0, totalCount: 0, frame: frameId, applet: appletId, appletHub: appletHubId }
                                    }

                                    messengers[parent].totalCount = messengers[parent].totalCount + count
                                }

                            }


                        }

                        // console.log("messengers[messenger._id]", messengers[messenger._id])


                        // console.log(appletId, frameId)
                        if (appletId && frameId && !doneFrames.includes(String(frameId))) {

                            doneFrames.push(String(frameId))

                            if (!object[appletId]) {
                                object[appletId] = { count: 0, frames: {}, info: messenger.applet }
                            }

                            object[appletId].count += count


                            if (!object[appletId].frames[frameId]) {
                                object[appletId].frames[frameId] = { list: [], count: 0, info: messenger.frame }
                            }

                            object[appletId].frames[frameId].count += count


                            if (appletHubId) {
                                if (!appletHubs[appletHubId]) {
                                    appletHubs[appletHubId] = { list: [], count: 0, info: messenger.appletHub }
                                }
                                appletHubs[appletHubId].count += count
                            }

                        }
                        // console.log(object[appletId])





                        if (!messengerIsDone) {

                            let type = 'messenger'
                            if (!categorizer[type]) {
                                categorizer[type] = { list: [], count: 0 }
                            }

                            categorizer[type].count += count

                            type = '*'
                            if (!categorizer[type]) {
                                categorizer[type] = { list: [], count: 0 }
                            }

                            categorizer[type].count += count

                            messengerIsDone = true

                        }



                    }
                }
            }
        }




    }

}



export default inboxReducer;